function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_4095",
  "data-name": "Path 4095",
  d: "M14.331,24.456a2.021,2.021,0,0,1,2.267.391q5.027,4.357,10.056,8.711a6.179,6.179,0,0,1,.643.594,2.064,2.064,0,0,1,.313,1.858,1.374,1.374,0,0,1-.673.846,2.1,2.1,0,0,1-1.235.094q-.008,4.933,0,9.866a1.472,1.472,0,0,1-1.222,1.449q-3.3,0-6.6,0a.514.514,0,0,1-.49-.5q0-4.347,0-8.7c-1.46,0-2.921-.009-4.382,0q0,4.318,0,8.635a.532.532,0,0,1-.248.487.865.865,0,0,1-.5.073H5.912a1.505,1.505,0,0,1-1.142-.95,2.51,2.51,0,0,1-.077-.885c0-3.159.006-6.318,0-9.477a2.092,2.092,0,0,1-1.248-.1,1.468,1.468,0,0,1-.706-1.021,1.982,1.982,0,0,1,.633-1.948l10.241-8.871a3.679,3.679,0,0,1,.723-.554m.342,1.023Q9.327,30.112,3.98,34.743a.781.781,0,0,0-.307.692.9.9,0,0,0,.261.5A.983.983,0,0,0,4.6,35.9c.275-.064.551-.285.839-.14a.679.679,0,0,1,.3.76q-.007,5.175,0,10.35c.005.1-.009.218.07.293a.43.43,0,0,0,.241.053h5.889c.018-2.907,0-5.815.008-8.722a.526.526,0,0,1,.553-.486c1.809,0,3.618,0,5.427,0a.542.542,0,0,1,.514.523c-.015.544,0,1.089-.008,1.634,0,2.35-.008,4.7.006,7.05h5.888c.1,0,.24,0,.284-.11a1.5,1.5,0,0,0,.03-.433q0-5.223,0-10.446a.525.525,0,0,1,.473-.512c.249-.024.455.144.69.195a1,1,0,0,0,.639.027.776.776,0,0,0,.226-.849,1.214,1.214,0,0,0-.37-.438q-5.2-4.5-10.4-9.01c-.213-.129-.382-.349-.643-.379A.738.738,0,0,0,14.673,25.479Z",
  transform: "translate(0 0)",
  fill: "#fff"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25.017,
    height: 24,
    viewBox: "0 0 25.017 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "_232020ff",
    "data-name": "#232020ff",
    transform: "translate(-2.688 -24.267)",
    style: {
      isolation: "isolate"
    }
  }, _ref2));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.4484ac17.svg";
export { ForwardRef as ReactComponent };